export { default } from './EdapModuleView';
